<div class="d-flex align-items-start g-g">
  <form
    [formGroup]="bandOptionsForm"
    (ngSubmit)="addBandOption()"
    class="d-flex align-items-center g-g w-50"
  >
    <div class="band-subsection form flex-fill">
      <div class="d-flex align-items-center g-g form-config">
        <label for="band" class="form-label">Band</label>
        <input
          id="band"
          type="number"
          formControlName="band"
          class="form-control"
          placeholder="e.g. 41"
        />
      </div>
      <div class="d-flex align-items-center g-g form-config">
        <label for="ssbArfcn" class="form-label">SSB</label>
        <input
          id="ssbArfcn"
          type="number"
          formControlName="ssbArfcn"
          class="form-control"
          placeholder="e.g. 518910"
        />
      </div>
      <div class="d-flex align-items-center g-g form-config">
        <label for="dlPointAArfcn" class="form-label">DL PointA</label>
        <input
          id="dlPointAArfcn"
          type="number"
          formControlName="dlPointAArfcn"
          class="form-control"
          placeholder="e.g. 517020"
        />
      </div>
      <div class="d-flex align-items-center g-g form-config">
        <label for="ulPointAArfcn" class="form-label">UL PointA</label>
        <input
          id="ulPointAArfcn"
          type="number"
          formControlName="ulPointAArfcn"
          class="form-control"
          placeholder="e.g. 517020"
        />
      </div>
    </div>
    <button
      type="submit"
      [disabled]="bandOptionsForm.invalid"
      class="btn btn-success"
    >
      <i class="fa-solid fa-circle-plus"></i>
      <i class="fa-solid fa-caret-right"></i>
    </button>
  </form>

  <ul
    class="flex-fill d-flex flex-column g-g band-subsection align-self-stretch"
  >
    <!-- Default -->
    @for (band of defaultBandOptions; track band; let i = $index) {
      <li
        class="d-flex align-items-center g-g justify-content-between band-option default"
      >
        <div class="d-flex align-items-center">
          <div class="band-type">Band n{{ band.band }}</div>
          <div class="d-flex flex-column">
            <div class="band-config-property">
              SSB ARFCN
              <span class="band-config-property-value">{{
                band.ssbArfcn
              }}</span>
            </div>
            <div class="band-config-property">
              DL PointA ARFCN
              <span class="band-config-property-value">{{
                band.dlPointAArfcn
              }}</span>
            </div>
            <div class="band-config-property">
              UL PointA ARFCN
              <span class="band-config-property-value">{{
                band.ulPointAArfcn
              }}</span>
            </div>
          </div>
        </div>
        <span>default</span>
      </li>
    }
    <!-- Custom -->
    @for (band of editableBandOptions; track band; let i = $index) {
      <li
        class="d-flex align-items-center g-g justify-content-between band-option"
      >
        <div class="d-flex align-items-center">
          <div class="band-type">Band n{{ band.band }}</div>
          <div class="d-flex flex-column">
            <div class="band-config-property">
              SSB ARFCN
              <span class="band-config-property-value">{{
                band.ssbArfcn
              }}</span>
            </div>
            <div class="band-config-property">
              DL PointA ARFCN
              <span class="band-config-property-value">{{
                band.dlPointAArfcn
              }}</span>
            </div>
            <div class="band-config-property">
              UL PointA ARFCN
              <span class="band-config-property-value">{{
                band.ulPointAArfcn
              }}</span>
            </div>
          </div>
        </div>
        <button (click)="removeBandOption(i)" class="remove-button">
          <i class="fa-solid fa-trash"></i>
        </button>
      </li>
    }
  </ul>
</div>
